import React from "react";
import ContactForm from "../../components/public/ContactForm";
import { useSettings, isOpenNow } from "../../lib/useSettings";
import { Icon } from "../../lib/icons";

function CgvDefault({ companyName, email, phone, siret, address }) {
  return (
    <>
      <section>
        <h2 className="font-display text-xl font-bold text-[color:var(--brand-navy)] mb-2 mt-6">1. Objet</h2>
        <p>Les présentes Conditions Générales de Vente (CGV) régissent les ventes conclues entre {companyName} — dont le siège est situé {address || "[adresse du siège]"}{siret ? `, ${siret}` : ""} — et toute personne physique ou morale ayant passé commande sur ce site.</p>
      </section>
      <section>
        <h2 className="font-display text-xl font-bold text-[color:var(--brand-navy)] mb-2 mt-6">2. Prix</h2>
        <p>Les prix sont indiqués en euros, toutes taxes comprises (TTC). Les frais de livraison éventuels sont précisés avant la validation de la commande. {companyName} se réserve le droit de modifier ses prix à tout moment, étant entendu que les produits seront facturés sur la base du tarif en vigueur au moment de l'enregistrement de la commande.</p>
      </section>
      <section>
        <h2 className="font-display text-xl font-bold text-[color:var(--brand-navy)] mb-2 mt-6">3. Commande</h2>
        <p>La commande n'est validée qu'après acceptation des présentes CGV et confirmation du paiement. Un e-mail récapitulatif est envoyé à l'adresse renseignée par le client.</p>
      </section>
      <section>
        <h2 className="font-display text-xl font-bold text-[color:var(--brand-navy)] mb-2 mt-6">4. Paiement</h2>
        <p>Le paiement s'effectue en ligne par carte bancaire via notre prestataire sécurisé <strong>Stripe</strong>. Les données de carte ne transitent pas par nos serveurs. Le paiement est débité immédiatement à la validation de la commande.</p>
      </section>
      <section>
        <h2 className="font-display text-xl font-bold text-[color:var(--brand-navy)] mb-2 mt-6">5. Livraison</h2>
        <p>Les modalités de livraison, délais et frais sont détaillés sur la page <a href="/livraison-retours" className="text-[color:var(--brand-sky)] underline">Livraison &amp; Retours</a>. Les délais sont donnés à titre indicatif et n'engagent pas la responsabilité de {companyName} en cas de retard indépendant de sa volonté.</p>
      </section>
      <section>
        <h2 className="font-display text-xl font-bold text-[color:var(--brand-navy)] mb-2 mt-6">6. Droit de rétractation</h2>
        <p>Conformément à l'article L.221-18 du Code de la consommation, le client dispose d'un délai de <strong>14 jours</strong> à compter de la réception du produit pour exercer son droit de rétractation, sans avoir à justifier de motif. Les modalités de retour sont précisées sur la page <a href="/livraison-retours" className="text-[color:var(--brand-sky)] underline">Livraison &amp; Retours</a>.</p>
      </section>
      <section>
        <h2 className="font-display text-xl font-bold text-[color:var(--brand-navy)] mb-2 mt-6">7. Garanties</h2>
        <p>Les produits bénéficient de la garantie légale de conformité (articles L.217-4 et suivants du Code de la consommation) et de la garantie des vices cachés (articles 1641 et suivants du Code civil). Pour toute demande, nous contacter à <strong>{email}</strong>.</p>
      </section>
      <section>
        <h2 className="font-display text-xl font-bold text-[color:var(--brand-navy)] mb-2 mt-6">8. Données personnelles</h2>
        <p>Les données collectées sont nécessaires au traitement de la commande. Elles sont traitées conformément à notre <a href="/confidentialite" className="text-[color:var(--brand-sky)] underline">Politique de confidentialité</a>. Vous disposez d'un droit d'accès, de rectification et de suppression.</p>
      </section>
      <section>
        <h2 className="font-display text-xl font-bold text-[color:var(--brand-navy)] mb-2 mt-6">9. Droit applicable — Litiges</h2>
        <p>Les présentes CGV sont régies par le droit français. En cas de litige, une solution amiable sera recherchée avant toute action judiciaire. À défaut, les tribunaux français seront seuls compétents. Conformément à l'article L.612-1 du Code de la consommation, le client peut recourir gratuitement au service de médiation <strong>MEDICYS</strong> (www.medicys.fr).</p>
      </section>
      <section>
        <h2 className="font-display text-xl font-bold text-[color:var(--brand-navy)] mb-2 mt-6">10. Contact</h2>
        <p>{companyName}{email && <> — {email}</>}{phone && <> — {phone}</>}</p>
      </section>
    </>
  );
}

function DeliveryReturnsDefault({ companyName, email }) {
  return (
    <>
      <section>
        <h2 className="font-display text-xl font-bold text-[color:var(--brand-navy)] mb-2 mt-4">Modes et délais de livraison</h2>
        <p>Les commandes sont préparées dans les meilleurs délais et expédiées depuis la France métropolitaine. Les délais moyens de livraison sont indiqués à titre informatif lors de la commande et peuvent varier selon le mode choisi (retrait en magasin, transporteur standard, coursier).</p>
      </section>
      <section>
        <h2 className="font-display text-xl font-bold text-[color:var(--brand-navy)] mb-2 mt-6">Frais de livraison</h2>
        <p>Les frais de port sont calculés automatiquement à l'étape de validation du panier, en fonction du poids, du mode de livraison et de la destination. Ils sont offerts au-delà d'un certain seuil d'achat précisé en page d'accueil.</p>
      </section>
      <section>
        <h2 className="font-display text-xl font-bold text-[color:var(--brand-navy)] mb-2 mt-6">Suivi de commande</h2>
        <p>Dès l'expédition de votre commande, un e-mail contenant le numéro de suivi vous est envoyé. Vous pouvez à tout moment suivre l'avancement depuis votre <a href="/account" className="text-[color:var(--brand-sky)] underline">espace client</a>.</p>
      </section>
      <section>
        <h2 className="font-display text-xl font-bold text-[color:var(--brand-navy)] mb-2 mt-6">Droit de rétractation — 14 jours</h2>
        <p>Conformément à l'article L.221-18 du Code de la consommation, vous disposez d'un délai de <strong>14 jours</strong> à compter de la réception de votre commande pour exercer votre droit de rétractation, sans avoir à justifier de motif ni à payer de pénalités.</p>
        <p className="mt-2">Pour exercer ce droit, contactez-nous à <strong>{email}</strong> en précisant le numéro de commande et les produits concernés. Un bon de retour vous sera envoyé.</p>
      </section>
      <section>
        <h2 className="font-display text-xl font-bold text-[color:var(--brand-navy)] mb-2 mt-6">Retours et remboursements</h2>
        <p>Les produits doivent être retournés dans leur état d'origine, non utilisés, dans leur emballage d'origine et accompagnés du bon de retour. Le remboursement est effectué par le même moyen de paiement que celui utilisé pour la commande, dans un délai maximum de <strong>14 jours</strong> à compter de la réception du retour.</p>
        <p className="mt-2">Les frais de retour restent à la charge du client, sauf en cas de produit défectueux ou d'erreur de notre part.</p>
      </section>
      <section>
        <h2 className="font-display text-xl font-bold text-[color:var(--brand-navy)] mb-2 mt-6">Produits défectueux ou non conformes</h2>
        <p>Si un produit reçu est défectueux, endommagé ou ne correspond pas à votre commande, signalez-le nous sous <strong>7 jours</strong> par e-mail à {email} avec photo à l'appui. {companyName} s'engage à procéder au remplacement ou au remboursement dans les meilleurs délais.</p>
      </section>
    </>
  );
}

function todayHoursLabel(hours = []) {
  const todayIdx = (new Date().getDay() + 6) % 7;
  const h = hours[todayIdx];
  if (!h) return "—";
  if (h.closed) return "Fermé aujourd'hui";
  const parts = [h.morning, h.afternoon].filter(Boolean);
  return parts.length ? parts.join(" · ") : "—";
}

export function ContactPage() {
  const { settings: s } = useSettings();
  const hours = s?.hours || [];
  const status = isOpenNow(hours);
  const todayLabel = todayHoursLabel(hours);
  const ci = s?.contact_icons || {};
  return (
    <>
      <title>{`Contact${s?.company_name ? " — " + s.company_name : ""}`}</title>
      <meta name="description" content={`Contactez-nous${s?.main_city ? " à " + s.main_city : ""}${s?.intervention_radius_km ? " et dans un rayon de " + s.intervention_radius_km + " km" : ""}. Réponse sous 24h.`}/>
      <section className="pt-14 pb-10 bg-[color:var(--brand-navy)] text-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <h1 className="font-display text-4xl md:text-6xl font-black">Contact</h1>
          <p className="mt-4 text-white/80 max-w-2xl">{s?.sector || "Professionnels"} — nous vous répondons sous 24h.</p>
        </div>
      </section>
      <section className="py-14">
        <div className="max-w-6xl mx-auto px-4 md:px-8 grid md:grid-cols-2 gap-10">
          <div className="space-y-6">
            {[
              { iconName: ci.phone || "Phone", label: "Téléphone", value: s?.phone, href: s?.phone ? `tel:${s.phone.replace(/\s/g,"")}` : "#" },
              { iconName: ci.email || "Mail", label: "Email", value: s?.email, href: s?.email ? `mailto:${s.email}` : "#" },
              { iconName: ci.address || "MapPin", label: "Adresse", value: s?.address_public, href: "#" },
              { iconName: ci.hours || "Clock", label: status.open ? "Ouvert maintenant" : "Horaires", value: todayLabel, hint: status.label, href: "#", testid: "contact-card-hours" },
            ].map((c, i) => (
              <a key={i} href={c.href} data-testid={c.testid} className="flex items-start gap-4 p-5 rounded-2xl border border-[hsl(var(--border))] bg-white hover:border-[color:var(--brand-sky)] transition">
                <div className="w-10 h-10 rounded-full bg-[color:var(--brand-navy)] text-white flex items-center justify-center flex-shrink-0">
                  <Icon name={c.iconName} className="w-4 h-4"/>
                </div>
                <div>
                  <div className="text-xs uppercase font-bold tracking-wider text-[hsl(var(--muted-foreground))]">{c.label}</div>
                  <div className="font-display font-bold text-[color:var(--brand-navy)]">{c.value || "—"}</div>
                  {c.hint && <div className="text-[11px] text-[color:var(--brand-sky)] font-semibold mt-0.5">{c.hint}</div>}
                </div>
              </a>
            ))}

            {/* Full weekly schedule */}
            {hours.length > 0 && (
              <div className="p-5 rounded-2xl border border-[hsl(var(--border))] bg-white" data-testid="contact-weekly-hours">
                <div className="text-xs uppercase font-bold tracking-wider text-[hsl(var(--muted-foreground))] mb-3">Semaine</div>
                <ul className="space-y-1 text-sm">
                  {hours.map((h, i) => {
                    const isToday = i === ((new Date().getDay() + 6) % 7);
                    return (
                      <li key={i} className={`flex justify-between gap-4 px-2 py-1 rounded ${isToday ? "bg-[color:var(--brand-sky)]/10 font-bold text-[color:var(--brand-navy)]" : "text-[hsl(var(--muted-foreground))]"}`}>
                        <span>{h.day}{isToday && <span className="ml-2 text-[10px] uppercase tracking-wider text-[color:var(--brand-sky)]">Auj.</span>}</span>
                        <span className="tabular-nums">{h.closed ? "Fermé" : `${h.morning || ""}${h.afternoon ? " · " + h.afternoon : ""}`.trim() || "—"}</span>
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}
          </div>
          <ContactForm defaultType="contact" title="Écrivez-nous" description="Un conseil, une question, un projet — nous vous répondons rapidement."/>
        </div>
      </section>
    </>
  );
}

export function DevisPage() {
  const { settings: s } = useSettings();
  return (
    <>
      <title>{`Devis gratuit${s?.company_name ? " — " + s.company_name : ""}`}</title>
      <meta name="description" content="Demandez votre devis gratuit en ligne. Réponse sous 24h, sans engagement."/>
      <section className="pt-14 pb-10 bg-[color:var(--brand-navy)] text-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <h1 className="font-display text-4xl md:text-6xl font-black">Devis gratuit</h1>
          <p className="mt-4 text-white/80 max-w-2xl">Étude personnalisée · Réponse sous 24h · 100% gratuit et sans engagement.</p>
        </div>
      </section>
      <section className="py-14">
        <div className="max-w-3xl mx-auto px-4 md:px-8">
          <ContactForm defaultType="devis" title="Votre demande de devis" description="Décrivez-nous votre projet — plus vous êtes précis, plus notre devis sera juste."/>
        </div>
      </section>
    </>
  );
}

export function LegalPage({ kind = "mentions" }) {
  const { settings: s } = useSettings();
  const titles = { mentions: "Mentions légales", cgv: "Conditions générales de vente", confidentialite: "Politique de confidentialité" };
  const companyName = s?.footer_legal_company || s?.company_name || "[Raison sociale]";
  const address = s?.address_headquarters || s?.address_public || "[Adresse du siège]";
  const director = s?.rgpd_publication_manager || s?.owner_name || "[Directeur de la publication]";
  const directorRole = s?.rgpd_publication_manager_role || "";
  const email = s?.email || "[email]";
  const phone = s?.phone || "[téléphone]";
  const siret = s?.footer_legal_siret || "";
  const extra = s?.footer_legal_extra || "";
  const hostName = s?.rgpd_host_name || "Infrastructure cloud France";
  const hostAddr = s?.rgpd_host_address || "";
  const hostContact = s?.rgpd_host_contact || "";
  const retention = s?.rgpd_data_retention_years ?? 3;
  const dataTypes = Array.isArray(s?.rgpd_data_types) && s.rgpd_data_types.length ? s.rgpd_data_types : [
    "Nom et prénom", "Adresse email", "Numéro de téléphone", "Adresse IP",
  ];
  const purposes = Array.isArray(s?.rgpd_data_purposes) && s.rgpd_data_purposes.length ? s.rgpd_data_purposes : [
    "Traitement des demandes", "Amélioration du site", "Communication marketing",
  ];
  const dpoName = s?.rgpd_dpo_name || "";
  const dpoEmail = s?.rgpd_dpo_email || email;
  const noResale = s?.rgpd_no_resale_mention !== false;
  const cookiesText = s?.rgpd_cookies_text || "";
  const legalExtra = s?.rgpd_legal_extra || "";
  const todayYear = new Date().getFullYear();

  return (
    <>
      <title>{`${titles[kind]}${s?.company_name ? " — " + s.company_name : ""}`}</title>
      <section className="py-14">
        <div className="max-w-3xl mx-auto px-4 md:px-8">
          <h1 className="font-display text-4xl font-black text-[color:var(--brand-navy)] mb-3">{titles[kind]}</h1>
          <p className="text-xs text-[hsl(var(--muted-foreground))] mb-8">Dernière mise à jour : {todayYear}</p>

          {kind === "mentions" && (
            <div className="text-[hsl(var(--muted-foreground))] leading-relaxed space-y-5">
              <section>
                <h2 className="font-display text-xl font-bold text-[color:var(--brand-navy)] mb-2">1. Éditeur du site</h2>
                <p><strong>Raison sociale :</strong> {companyName}<br />
                <strong>Siège :</strong> {address}<br />
                <strong>Directeur de la publication :</strong> {director}{directorRole ? ` (${directorRole})` : ""}<br />
                {siret && <><strong>{siret}</strong><br /></>}
                <strong>Contact :</strong> {email} · {phone}</p>
              </section>

              <section>
                <h2 className="font-display text-xl font-bold text-[color:var(--brand-navy)] mb-2">2. Hébergement</h2>
                <p><strong>{hostName}</strong>
                {hostAddr && <><br />{hostAddr}</>}
                {hostContact && <><br />Contact : {hostContact}</>}
                </p>
              </section>

              <section>
                <h2 className="font-display text-xl font-bold text-[color:var(--brand-navy)] mb-2">3. Propriété intellectuelle</h2>
                <p>Les contenus (textes, images, logos, graphismes) présents sur ce site sont la propriété exclusive de {companyName} ou de ses partenaires. Toute reproduction, même partielle, est strictement interdite sans autorisation écrite préalable.</p>
              </section>

              <section>
                <h2 className="font-display text-xl font-bold text-[color:var(--brand-navy)] mb-2">4. Données personnelles</h2>
                <p>Les informations transmises via nos formulaires sont collectées et traitées par {companyName}. Pour en savoir plus sur leur utilisation, consultez notre <a className="text-[color:var(--brand-sky)] underline" href="/confidentialite">Politique de confidentialité</a>.</p>
              </section>

              {extra && <p className="whitespace-pre-line text-sm italic">{extra}</p>}
              {legalExtra && <p className="whitespace-pre-line text-sm">{legalExtra}</p>}
            </div>
          )}

          {kind === "confidentialite" && (
            <div className="text-[hsl(var(--muted-foreground))] leading-relaxed space-y-5">
              <section>
                <h2 className="font-display text-xl font-bold text-[color:var(--brand-navy)] mb-2">1. Responsable du traitement</h2>
                <p>{companyName} — représenté par {director}{directorRole ? ` (${directorRole})` : ""} — est responsable du traitement des données collectées sur ce site. Contact : {email}{phone && ` · ${phone}`}.</p>
                {dpoName && <p>Délégué à la protection des données : <strong>{dpoName}</strong> — {dpoEmail}.</p>}
              </section>

              <section>
                <h2 className="font-display text-xl font-bold text-[color:var(--brand-navy)] mb-2">2. Données collectées</h2>
                <p>Nous collectons uniquement les informations nécessaires :</p>
                <ul className="list-disc ml-6 space-y-1 mt-2">{dataTypes.map((d, i) => <li key={i}>{d}</li>)}</ul>
              </section>

              <section>
                <h2 className="font-display text-xl font-bold text-[color:var(--brand-navy)] mb-2">3. Finalités du traitement</h2>
                <p>Vos données sont utilisées pour :</p>
                <ul className="list-disc ml-6 space-y-1 mt-2">{purposes.map((p, i) => <li key={i}>{p}</li>)}</ul>
                {noResale && (
                  <p className="mt-3 px-3 py-2 rounded-lg bg-emerald-50 text-emerald-800 text-sm border border-emerald-200">
                    ✓ Vos données ne sont <strong>jamais revendues</strong> à des tiers. Elles sont utilisées uniquement par {companyName} à des fins d'amélioration du site et de communication marketing propre à notre entreprise.
                  </p>
                )}
              </section>

              <section>
                <h2 className="font-display text-xl font-bold text-[color:var(--brand-navy)] mb-2">4. Durée de conservation</h2>
                <p>Les données sont conservées pendant une durée maximale de <strong>{retention} an{retention > 1 ? "s" : ""}</strong> à compter du dernier contact, sauf obligation légale de conservation plus longue (comptabilité, fiscalité).</p>
              </section>

              <section>
                <h2 className="font-display text-xl font-bold text-[color:var(--brand-navy)] mb-2">5. Vos droits</h2>
                <p>Conformément au RGPD et à la loi "Informatique et Libertés", vous disposez des droits suivants :</p>
                <ul className="list-disc ml-6 space-y-1 mt-2">
                  <li>Droit d'accès à vos données</li>
                  <li>Droit de rectification</li>
                  <li>Droit à l'effacement (« droit à l'oubli »)</li>
                  <li>Droit à la limitation du traitement</li>
                  <li>Droit à la portabilité de vos données</li>
                  <li>Droit d'opposition au traitement</li>
                </ul>
                <p className="mt-3">Pour exercer ces droits, contactez-nous par email à <strong>{dpoEmail}</strong>. Si vous estimez, après nous avoir contactés, que vos droits ne sont pas respectés, vous pouvez adresser une réclamation à la <a className="text-[color:var(--brand-sky)] underline" href="https://www.cnil.fr/fr/plaintes" target="_blank" rel="noopener noreferrer">CNIL</a>.</p>
              </section>

              <section>
                <h2 className="font-display text-xl font-bold text-[color:var(--brand-navy)] mb-2">6. Cookies</h2>
                <p>{cookiesText || "Ce site utilise des cookies techniques nécessaires à son fonctionnement ainsi que des cookies de mesure d'audience pour améliorer votre expérience. Vous pouvez à tout moment refuser les cookies non essentiels via les paramètres de votre navigateur."}</p>
              </section>

              {legalExtra && (
                <section>
                  <h2 className="font-display text-xl font-bold text-[color:var(--brand-navy)] mb-2">7. Dispositions particulières</h2>
                  <p className="whitespace-pre-line">{legalExtra}</p>
                </section>
              )}
            </div>
          )}

          {kind === "cgv" && (
            <div className="text-[hsl(var(--muted-foreground))] leading-relaxed space-y-3">
              {s?.cgv_content ? (
                <div className="prose prose-slate max-w-none [&>h2]:font-display [&>h2]:text-xl [&>h2]:font-bold [&>h2]:text-[color:var(--brand-navy)] [&>h2]:mt-6 [&>h2]:mb-2 [&>h3]:font-display [&>h3]:font-bold [&>h3]:text-[color:var(--brand-navy)] [&>ul]:list-disc [&>ul]:ml-6 [&>ol]:list-decimal [&>ol]:ml-6 [&_a]:text-[color:var(--brand-sky)] [&_a]:underline" dangerouslySetInnerHTML={{ __html: s.cgv_content }} data-testid="cgv-content" />
              ) : (
                <>
                  <CgvDefault companyName={companyName} email={email} phone={phone} siret={siret} address={address} />
                  {legalExtra && <p className="whitespace-pre-line">{legalExtra}</p>}
                </>
              )}
              {s?.cgv_updated_at && (
                <p className="text-[11px] italic text-[hsl(var(--muted-foreground))] mt-8 pt-4 border-t">
                  Dernière mise à jour : {new Date(s.cgv_updated_at).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" })}
                </p>
              )}
            </div>
          )}
        </div>
      </section>
    </>
  );
}


export function DeliveryReturnsPage() {
  const { settings: s } = useSettings();
  const companyName = s?.footer_legal_company || s?.company_name || "[Raison sociale]";
  const email = s?.email || "[email]";
  const todayYear = new Date().getFullYear();
  const deliveryHtml = s?.delivery_policy_content || "";
  const returnsHtml = s?.returns_policy_content || "";

  return (
    <>
      <title>{`Livraison & Retours${s?.company_name ? " — " + s.company_name : ""}`}</title>
      <section className="py-14">
        <div className="max-w-3xl mx-auto px-4 md:px-8">
          <div className="text-xs uppercase tracking-[0.25em] text-[color:var(--brand-sky)] font-bold mb-2">Informations pratiques</div>
          <h1 className="font-display text-4xl font-black text-[color:var(--brand-navy)] mb-3">Livraison &amp; Retours</h1>
          <p className="text-xs text-[hsl(var(--muted-foreground))] mb-8">Dernière mise à jour : {todayYear}</p>

          <div className="text-[hsl(var(--muted-foreground))] leading-relaxed space-y-3" data-testid="delivery-returns-content">
            {deliveryHtml || returnsHtml ? (
              <>
                {deliveryHtml && (
                  <div className="prose prose-slate max-w-none [&>h2]:font-display [&>h2]:text-xl [&>h2]:font-bold [&>h2]:text-[color:var(--brand-navy)] [&>h2]:mt-6 [&>h2]:mb-2 [&_a]:text-[color:var(--brand-sky)] [&_a]:underline" dangerouslySetInnerHTML={{ __html: deliveryHtml }} />
                )}
                {returnsHtml && (
                  <div className="prose prose-slate max-w-none mt-6 [&>h2]:font-display [&>h2]:text-xl [&>h2]:font-bold [&>h2]:text-[color:var(--brand-navy)] [&>h2]:mt-6 [&>h2]:mb-2 [&_a]:text-[color:var(--brand-sky)] [&_a]:underline" dangerouslySetInnerHTML={{ __html: returnsHtml }} />
                )}
              </>
            ) : (
              <DeliveryReturnsDefault companyName={companyName} email={email} />
            )}
            {s?.delivery_returns_updated_at && (
              <p className="text-[11px] italic text-[hsl(var(--muted-foreground))] mt-8 pt-4 border-t">
                Mise à jour : {new Date(s.delivery_returns_updated_at).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" })}
              </p>
            )}
          </div>
        </div>
      </section>
    </>
  );
}
